var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner-home'),_c('about-home'),_c('step-home'),_c('benefits-home'),_c('contact-home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }